/* esm.sh - mdast-util-find-and-replace@3.0.2 */
export * from "/*mdast-util-find-and-replace@3.0.2/esnext/mdast-util-find-and-replace.mjs";
